import React, { Component } from "react";
import Server from "./Server";

import classNames from "classnames";
import { withStyles, createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import InputMask from "react-input-mask";
import Stepper from "./Stepper";
import Divider from "./Divider";
import CityList from "./CityList";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import { fetchLoaderRun } from "../actions";
import MessageComponent from "./MessageComponent";
import { scrollTo } from "scroll-js";
import { connect } from "react-redux";

const myTheme = createMuiTheme({
	palette: {
		primary: {
			light: "#1db6d8",
			main: "#1d99b4",
			dark: "#1b96b1",
			contrastText: "#fff"
		},
		secondary: {
			light: "#ff7961",
			main: "#f44336",
			dark: "#ba000d",
			contrastText: "#000"
		}
	},
	typography: {
		useNextVariants: true
	}
});

const styles = (theme) => ({
	root: {
		margin: "0 auto"
	},
	container: {
		display: "flex",
		flexWrap: "wrap"
	},
	textField: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit
	},
	dense: {
		width: "100%",
		marginTop: 16,
		marginLeft: 0
	},
	menu: {
		width: 200
	},
	margin: {
		margin: theme.spacing.unit
	},
	extendedIcon: {
		marginRight: theme.spacing.unit
	}
});

class Calculation extends Component {
	state = {
		fetchDelay: null,
		postCode: "",
		cityList: null,
		filteredList: null,
		pickedCity: null,
		message: { type: null, text: null },
		langBase: this.props.langBase
	};

	controller = new AbortController();

	cityPostalCode = (value) => {
		if (value.match(/^\d{2}-\d{3}$/g)) {
			this.props.fetchLoaderRun(true);
			this.controller = new AbortController();
			fetch(Server.calculate + "?postal=" + value, {
				mode: "cors",
				redirect: "follow",
				credentials: "include",
				signal: this.controller.signal
			})
				.then((resp) => resp.json())
				.then((data) => {
					!data.responseCode &&
						this.setState({
							message: {
								type: "i",
								text: this.state.langBase.cityFound + ": " + data.length
							},
							cityList: data.sort(
								(a, b) => (a.miejscowosc > b.miejscowosc ? 1 : b.miejscowosc > a.miejscowosc ? -1 : 0)
							)
						});
					data.responseCode &&
						this.setState({
							message: { type: "e", text: data.responseDesc }
						});
					this.props.fetchLoaderRun(false);
				})
				.catch((error) => {
					if (error.code !== 20) {
						this.setState({
							message: { type: "e", text: error }
						});
					}
				});
		}
	};

	scrollToTop = (pos) => {
		const calcBody = document.querySelector(".calc-body");
		calcBody &&
			scrollTo(calcBody, {
				top: pos,
				duration: 1000,
				easing: "ease-out"
			}).then(() => {});
	};

	inputHandler = (e) => {
		this.scrollToTop(0);
		const value = e.target.value;
		if (value.match(/^\d{2}-\d{3}$/g)) {
			this.setState({
				postCode: value
			});
			this.cityPostalCode(value);
		} else {
			this.setState({
				message: { type: null, text: null },
				postCode: value,
				cityList: null,
				filteredList: null,
				pickedCity: null
			});
		}
	};

	componentWillUnmount() {
		this.controller.abort();
	}

	filterCities = (value) => {
		if (value) {
			const filteredList = [ ...this.state.cityList ].filter((a) => {
				return a.miejscowosc.toLowerCase().includes(value.toLowerCase());
			});
			this.setState({ filteredList });
		} else {
			this.setState({ filteredList: null });
		}
	};

	pickCity = (value) => {
		this.setState({ pickedCity: value });

		fetch(Server.calculate + "?city=" + value, {
			mode: "cors",
			redirect: "follow",
			credentials: "include"
		});
	};

	render() {
		const { classes, langBase } = this.props;
		return (
			<MuiThemeProvider theme={myTheme}>
				{(this.state.pickedCity && (
					<div className="pickedCity">
						<div className="cityName">{this.state.pickedCity}</div>
						<IconButton
							onClick={() => {
								this.setState({ pickedCity: null, filteredList: null });
							}}
							aria-label="Delete"
							className={classes.margin}>
							<ClearIcon fontSize="small" />
						</IconButton>
					</div>
				)) || (
					<React.Fragment>
						<Divider width="100" />
						<InputMask
							mask="99-999"
							//value={this.state.postCode}
							onChange={this.inputHandler}
							className={"inputPostal " + classNames(classes.textField, classes.dense)}
							value={this.state.postCode}>
							{() => (
								<TextField
									id="outlined-dense"
									type="text"
									ref="postalCode"
									label={langBase.postalCode || "Wpisz kod pocztowy miejscowośći"}
									name="postalCode"
									className={"inputPostal " + classNames(classes.textField, classes.dense)}
									margin="dense"
									variant="outlined"
									autoComplete="off"
								/>
							)}
						</InputMask>
						<MessageComponent type={this.state.message.type} message={this.state.message.text} />
						{this.state.cityList && (
							<CityList
								langBase={langBase}
								pickCity={this.pickCity}
								filterCities={this.filterCities}
								cityList={this.state.filteredList || this.state.cityList}
							/>
						)}
					</React.Fragment>
				)}

				<Stepper close={this.props.close} />
			</MuiThemeProvider>
		);
	}
}

const mapStateToProps = (state) => ({
	langBase: state.langBase
});

const mapDispatchToProps = {
	fetchLoaderRun
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Calculation));
